import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface InfoButtonProps {
  title: string;
  content: string;
}

const InfoButton: React.FC<InfoButtonProps> = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="ml-2 w-5 h-5 rounded-full bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-200 
                   text-xs flex items-center justify-center transition-colors duration-200
                   focus:outline-none focus:ring-2 focus:ring-blue-400"
        aria-label={t('common.information')}
      >
        i
      </button>

      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          onClick={() => setIsOpen(false)}
        >
          <div 
            className="bg-white dark:bg-gray-900 rounded-lg shadow-xl max-w-md w-full p-6 animate-fade-in"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-3">{title}</h3>
            <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed mb-4">{content}</p>
            <button
              onClick={() => setIsOpen(false)}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 
                         rounded-lg transition-colors duration-200"
            >
              {t('common.understood')}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default InfoButton;
